import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-additional-info',
  styleUrls: ['additional-info.component.scss'],
  templateUrl: 'additional-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdditionalInfoComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() additionalInfoKey$: Observable<string>;
}
